import { render } from "./ItemListPremi.vue?vue&type=template&id=0742c59a&scoped=true"
import script from "./ItemListPremi.vue?vue&type=script&lang=js"
export * from "./ItemListPremi.vue?vue&type=script&lang=js"

import "./ItemListPremi.vue?vue&type=style&index=0&id=0742c59a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0742c59a"]])

export default __exports__